import { decodeBuyCheckToken } from "./buy-check-token";
import type { NextChallenge } from "./buy-check-token.types";
import type { ChallengeStep } from "./challenge-config.types";

function str(params: NextChallenge["params"], key: string): string | undefined {
  const value = params?.[key];
  return typeof value === "string" && value ? value : undefined;
}

/** Null for a type this frame cannot render, or one missing a required param. */
export function toChallengeConfig(next: NextChallenge): ChallengeStep | null {
  const { params } = next;
  switch (next.type) {
    case "cvc": {
      const cardId = str(params, "cardId");
      return cardId
        ? {
            type: "cvc",
            cardId,
            lastDigits: str(params, "lastDigits"),
            brand: str(params, "brand"),
          }
        : null;
    }
    case "wallet_ownership": {
      const walletAddress = str(params, "walletAddress");
      const ownershipType = str(params, "ownershipType");
      return walletAddress && ownershipType
        ? {
            type: "wallet_ownership",
            walletAddress,
            ownershipType,
            networkCode: str(params, "networkCode"),
            walletAddressTag: str(params, "walletAddressTag"),
          }
        : null;
    }
    case "three_ds": {
      const url = str(params, "url");
      return url ? { type: "three_ds", url } : null;
    }
    case "kyc":
    case "identity_verification":
      return { type: next.type };
    default:
      return null;
  }
}

/** The token a challenge URL carries is the one to post back when that challenge resolves. */
export function challengeTokenOf(challengeUrl: string): string | null {
  try {
    return new URL(challengeUrl).searchParams.get("challengeToken");
  } catch {
    return null;
  }
}

export function configFromToken(challengeToken: string): ChallengeStep | null {
  const next = decodeBuyCheckToken(challengeToken)?.params.nextChallenge;
  return next ? toChallengeConfig(next) : null;
}
